import { MenuItem } from '@material-ui/core';
import React from 'react';

import useMaintenanceStatuses from 'core/hooks/useMaintenanceStatuses';
import { InputField, InputFieldProps } from 'Elements/Form';

export default function MaintenanceStatusSelect({
  name = 'maintenance_status_id',
  ...props
}: InputFieldProps) {
  const statuses = useMaintenanceStatuses();

  return (
    <InputField
      name={name}
      select
      placeholder="Valitse"
      InputLabelProps={{
        shrink: true
      }}
      {...props}
    >
      {statuses.map(status => (
        <MenuItem key={status.id} value={status.id}>
          {status.label}
        </MenuItem>
      ))}
    </InputField>
  );
}
